export const getters = {
  getServices($state) {
    return Object.values($state.records).sort((a, b) => a.id - b.id);
  },
  getServiceById: $state => id => {
    return (
      Object.values($state.records).find(record => record.id === Number(id)) ||
      {}
    );
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getService: $state => id => {
    const service = $state.records[id];
    return service || {};
  },
};

